import { initializeApp } from 'firebase/app';
import { getAuth, signOut, getRedirectResult, onAuthStateChanged } from 'firebase/auth';
export { getRedirectResult, onAuthStateChanged };
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import firebaseConfig from '../firebase-applet-config.json';

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);

// Use the provided database ID if it exists, otherwise use default
export const db = (firebaseConfig as any).firestoreDatabaseId 
  ? getFirestore(app, (firebaseConfig as any).firestoreDatabaseId)
  : getFirestore(app);

export const logout = () => signOut(auth);
